const HeadTitle = ({headTitle}) => {
  return (
    <div className='p-0 m-0 d-flex align-items-center'>
      <div className={"pageHeading CathaySansBd"} style={{ fontSize: "32px", lineHeight: "36px" }}>{headTitle}</div>
  </div>
  )
};

export default HeadTitle;